// extracted by mini-css-extract-plugin
export var fadeInOut = "_2p-3";
export var icon = "_2p-4";
export var savedIndicator = "_2p-2";
export var savingIndicator = "_2p-0";
export var spin = "_2p-1";